import InviteLeadToApplyModalContainer from "./InviteLeadToApplyModalContainer";

export default InviteLeadToApplyModalContainer;
